import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16 18H13V2L11 2V18H8L12 22L16 18Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SmallLongDown"
);
